/**
 * MacroCommand — Sprint 21.7.2 Domain Command Center.
 * Home for macro · Fed policy · inflation · geopolitics · regime. Backed
 * by ATLAS until Phase 2 Monetary/Geopolitical specialists land.
 */
import { useEffect } from 'react';
import { Globe } from 'lucide-react';
import CommandCenterLayout from '../../components/CommandCenter/CommandCenterLayout.jsx';
import { usePage } from '../../contexts/PageContext.jsx';

export default function MacroCommand() {
  const { setPage } = usePage();
  useEffect(() => { setPage('command-macro'); }, []);
  return (
    <CommandCenterLayout
      domain="macro"
      title="Macro Command"
      icon={<Globe className="w-5 h-5" />}
      subtitle="Fed policy · inflation · geopolitics · regime"
    />
  );
}
